export default __webpack_public_path__ + "static/media/copy-link.09f13b5f.svg";